// Libraries
import { InjectionToken } from '@angular/core';

// Models
import { MockupPathConfig } from './mockup-path-config.interface';
import { MockupErrorResponse } from './mockup-error-response.interface';

export interface MockupConfig {
  enabled: boolean;
  paths: MockupPathConfig[];
  // Optional
  errorResponse?: MockupErrorResponse;
}

export const MOCKUP_CONFIG = new InjectionToken<MockupConfig>('mockup MOCKUP_CONFIG');
